// extracted by mini-css-extract-plugin
export default {"root":"eW3_Ey","title":"Oyqx3k","buttons":"ptzUgR","buttonWrapper":"MTSL7E"};